import buffer from 'buffer';

// eslint-disable-next-line n/prefer-global/buffer
export const Buffer = buffer.Buffer;
